import React from "react";
import Hero from "../components/Hero";

const Home = () => {
  return (
    <main>
      <Hero />
    </main>
  );
};

export default Home;
